import React from 'react';

import SendFeedbackPanel from './SendFeedbackPanel';

import styles from '../../styles/DynamicModal.module.css';

const SendFeedbackModal = ({ closeModal }) => {
  return (
    <div className={styles.liningOver}>
      <SendFeedbackPanel closeModal={closeModal} />
    </div>
  )
}

export default SendFeedbackModal;